
import React, { useState, useEffect, useCallback } from 'react';
import { Navigate, useParams } from "react-router-dom";

import Grid from '@mui/material/Grid2';
// import { 
//   User,
// } from "../../../../models";
import { 
  Encounter,
  Character,
  BasicCreatureInstance,
  // EncounterLog,
  CustomParticipant,
  SummonInstance,
  TransformInstance,
  CharacterAbility,
  CharacterSpell,
  Spell,
  SummonOption2,
  CreatureAbility,
  MinionAbility,
  EncounterParticipant,
  Campaign,
  ComplexCreatureInstance,
} from "@dndModels";

import API from "@dndUtilities/system_api";
// import UserAPI from "../../../../utilities/user_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";

import EditableLabel from "@components/input/strings/EditableLabel";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import LoadingBox from "@components/input/LoadingBox";

import AddParticipants from "@dndComponents/encounter/AddParticipants";
import InitiativeTracker from "@dndComponents/encounter/InitiativeTracker";

import CreatureInstanceInput from "@dndComponents/creature/CreatureInstanceInput";
import LairActionsInput from "@dndComponents/creature/LairActionsInput";
import SelectPlayerObjectBox from "@dndComponents/select/SelectPlayerObjectBox";
import AddCharacterParticipants from "@dndComponents/encounter/AddCharacterParticipants";
import FilterBox from "@dndComponents/filtering/FilterBox";
import ColorButtonBox from "@components/input/buttons/ColorButtonBox";
import SendToCharacters from "@dndComponents/campaign/SendToCharacters";
import MailButton from "@components/input/buttons/MailButton";
import CharConnectUtilities from '@dndUtilities/char_connect_utilities';

const api = API.getInstance();
// const user_api = UserAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function EncounterDetails() {
  const { id } = useParams();
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading_campaign, setLoadingCampaign] = useState(false);
  const [reloading_view, setReLoadingView] = useState(false);
  const [loading_message, setLoadingMessage] = useState("");
  const [obj, setObj] = useState<Encounter>(new Encounter());
  const [change_time, setChangeTime] = useState(0);
  const [view_mode, setViewMode] = useState("Description/Selection");
  const [selected_participant_id, setSelectedParticipantID] = useState("");
  const [selected_ci_id, setSelectedCIID] = useState("");
  const [calculate_time, setCalculateTime] = useState(0);
  // const [char_reloads, setCharReloads] = useState<{ [char_id: string]: number }>({});
  const [char_reloading, setCharReloading] = useState(false);
  const [ping, setPing] = useState(false);
  const [selected_campaign_id, setSelectedCampaignId] = useState("");
  const [color, setColor] = useState("white");
  const [filter, setFilter] = useState<any>({});
  const [mail_open, setMailOpen] = useState(false);
  
  // const height = window.innerHeight - 64;

  // eslint-disable-next-line
  useEffect(() => {
    if (!fetched) {
      if (api.user === null) {
        const userObjStr = localStorage.getItem("loginUser");
        if (!userObjStr) {
          setFetched(true);
        } else {
          // if (!char_util.ready && !char_util.loading) {
          //   char_util.loadData();
          // }
          setFetched(true);
          setLoading(true);
          check_login();
        }
      } else {
        // if (!char_util.ready && !char_util.loading) {
        //   char_util.loadData();
        // }
        setFetched(true);
        setLoading(true);
        check_login();
      }
    }
  });

  useEffect(() => {
    if (reloading_view) {
      setReLoadingView(false);
    }
  }, [reloading_view, setReLoadingView]);

  useEffect(() => {
    if (char_reloading) {
      setCharReloading(false);
    }
  }, [char_reloading]);

  const loadCampaignAndCharacters = useCallback(async (new_obj: Encounter) => {
    setSelectedCampaignId(new_obj.campaign_id);
    await loadCampaign(new_obj);
    let participant_ids = new_obj.participants.filter(o => 
      o.participant_type === "Character" && o.participant === null).map(o => o.participant_id);
    if (new_obj.campaign) {
      const campaign_char_ids = new_obj.campaign.characters.map(o => o._id);
      participant_ids = participant_ids.filter(o => !campaign_char_ids.includes(o));
    }
    if (participant_ids.length > 0) {
      const onProgress = (data_type: string, percentage: number) => {
        if (percentage !== 0) {
          setLoadingMessage(`Loading Characters ${Math.floor(percentage * 100)}%`);
        } else {
          setLoadingMessage(`Loading Characters`);
        }
      };
      // debugger;
      const res = await api.getPlayerObjects({ 
        data_type: "character", 
        filter: { "_id*ObjectIDs": participant_ids },
        onProgress
      });
      for (const char of res) {
        if (char instanceof Character) {
          const participant = new_obj.participants.find(o => 
            o.participant_type === "Character" && o.participant_id === char._id);
          if (participant) {
            participant.participant = char;
            if (participant.owner_id === "") {
              participant.owner_id = char.owner_id;
            }
          }
        }
      }
      const missing_characters = new_obj.participants.filter(o => 
        o.participant_type === "Character" && !o.participant).map(o => o.participant_id);
      if (missing_characters.length > 0) {
        // Characters were deleted, so we need to remove their participants as well.
        new_obj.participants = new_obj.participants.filter(o => !missing_characters.includes(o.participant_id));
      }
    } 
  }, []);

  const loadCampaign = useCallback(async (new_obj: Encounter) => {
    // if (new_obj.campaign_id !== "") {
    //   // debugger;
    //   let filter: any = { "_id*ObjectIDs": [new_obj.campaign_id] };
    //   setLoadingMessage(`Loading Campaign`);
    //   let res = await api.getPlayerObjects<Character>({ 
    //     data_type: "campaign", 
    //     filter
    //   });
    //   if (res && res.length === 1 && res[0] instanceof Campaign) {
    //     new_obj.campaign = res[0];
        
    //     // debugger;
    //     filter = { campaign_id: new_obj.campaign_id };
    //     setLoadingMessage(`Loading Campaign Characters`);
    //     res = await api.getPlayerObjects({ 
    //       data_type: "character", 
    //       filter
    //     });
    //     if (res) {
    //       new_obj.campaign.characters = res.filter(o => o.active && !o.is_archived);
    //       // debugger;
    //       for (const char of new_obj.campaign.characters) {
    //         const participant = new_obj.participants.find(o => 
    //           o.participant_type === "Character" && o.participant_id === char._id);
    //         if (participant) {
    //           participant.participant = char;
    //           if (participant.owner_id === "") {
    //             participant.owner_id = char.owner_id;
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
  }, []);

  const load = useCallback( async () => {
    if (id && id !== "") {
      const res = await api.getObjectFromAPI<Encounter>({ data_type: "encounter", id });
      if (res) {
        const new_obj = res;
        await connect_util.connectEncounterCreatures(new_obj);
        // console.log(new_obj.clone());
        if (new_obj.participants.length > 0) {
          let add_time = common_util.get_time_number();
          new_obj.participants.filter(o => o.add_time === -1).forEach(part => {
            part.add_time = add_time++;
          });
        }
        await loadCampaignAndCharacters(new_obj);
        setObj(new_obj);
        setCalculateTime(common_util.get_time_number());
        setLoading(false);
      }
    }
  }, [loadCampaignAndCharacters]);

  const updateEncounter = useCallback( async (onComplete: Function | null = null, new_change_time = -1) => {
    if (new_change_time === -1) {
      new_change_time = common_util.get_time_number();
      if (new_change_time < change_time + 5) {
        new_change_time = change_time;
      }
    }
    if (change_time !== new_change_time) {
      setChangeTime(new_change_time);
    }
    // debugger;
    await api.updateObject("encounter", obj);
    if (onComplete) {
      onComplete();
    }
    setPing(!ping);
  }, [obj, ping]);

  useEffect(() => {
    if (selected_campaign_id !== obj.campaign_id && obj._id !== "") {
      obj.campaign_id = selected_campaign_id;
      updateEncounter();
      setLoadingCampaign(true);
      loadCampaign(obj).then(() => {
        setLoadingCampaign(false);
      });
    }
  }, [selected_campaign_id, obj, setLoadingCampaign, loadCampaign]);

  const check_login = () => {
    setTimeout(() => {
      if (api.user === null) {
        if (loading_message === "") {
          setLoadingMessage("Logging In");
        }
        check_login();
      } else {
        setLoadingMessage("Loading Encounter");
        load();
      }
    }, 1000);
  }

  const updateFilter = (the_filter: any, startLetter = "") => {
    const new_filter = {...the_filter};
    
    if (startLetter !== "") {
      new_filter["name*startsWith"] = startLetter;
    } else {
      delete new_filter["name*startsWith"];
    }

    setFilter(new_filter);
  }

  const renderView = () => {
    if (api.user === null || reloading_view) {
      return null;
    } else if (view_mode === "Add Participants") {
      return (
        <>
          <AddParticipants
            obj={obj}
            change_time={change_time}
            onChange={() => {
              updateEncounter();
              setCalculateTime(common_util.get_time_number());
            }}
          />
        </>
      );
    } else if (view_mode === "Loot Controls") {
      return (
        <>
          Coming Soon
        </>
      );
    } else if (view_mode === "Campaign") {
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <SelectPlayerObjectBox 
              name="Campaign"
              data_type="campaign"
              filter={{ owner_id: api.user ? api.user._id : "", is_archived: false }}
              value={selected_campaign_id}
              onChange={(changed: string) => {
                setSelectedCampaignId(changed);
              }}
            />
          </Grid>
          { loading_campaign ?
            <Grid size={12}><LoadingBox message="Loading Campaign" /></Grid>
          : obj.campaign &&
            <>
              <Grid size={10}>
                <FilterBox
                  data_type='character'
                  dont_use_api
                  the_filter={filter}
                  onChange={updateFilter}
                  // log_it
                  quick_fields={["game_class","subclass","race","subrace"]}
                />
              </Grid>
              <Grid size={1}>
                <ColorButtonBox 
                  color={color}
                  onChange={setColor}
                />
              </Grid>
              <Grid
                size={{
                  xs: 1
                }}>
                <MailButton
                  onClick={() => {
                    setMailOpen(true);
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12
                }}>
                <AddCharacterParticipants 
                  obj={obj} 
                  characters={obj.campaign.characters} 
                  filter={filter} 
                  change_time={change_time} 
                  color={color} 
                  onChange={() => {
                    updateEncounter();
                    setCalculateTime(common_util.get_time_number());
                  }}
                />
              </Grid>
              { renderExtras() }
            </>
          }
        </Grid>
      );
    } else {
      const participant = obj.participants.find(o => o.participant_id === selected_participant_id);
      if (participant) {
        if (participant.participant instanceof Character) {
          // const char = participant.participant;
          // let shared = true;
          // const user = api.user;
          // if (user._id === char.owner_id) {
          //   shared = false;
          // } else if (char.campaign && char.campaign.owner_id === user._id) {
          //   shared = false;
          // }
          // if (shared) {
          //   return (
          //     <CharacterSheet
          //       char_id={participant.participant_id}
          //       character={char}
          //       height={height}
          //       width={window.innerWidth * 0.6}
          //       disabled={char.owner_id !== user._id}
          //       shared
          //       updateCharacter={(char: Character, pieces: string[] = ["all"]) => {
          //         updateCharacter(char, pieces);
          //       }}
          //       onChange={() => {
          //         const new_obj = obj.clone();
          //         const log = new EncounterLog();
          //         log.participant_id = participant.participant_id;
          //         log.field = "character";
          //         log.value = "refresh";
          //         updateEncounter(new_obj, log);
          //       }}
          //     />
          //   );
          // } else {
          //   const last_reload = char_reloads[char._id] || -1;
          //   return (
          //     <Grid container spacing={0} direction="row">
          //       <Grid item xs={12}>
          //         <CharacterSaveTools
          //           character={char}
          //           last_reload={last_reload}
          //           onReload={(changed: Character) => {
          //             debugger;
          //             updateCharacter(changed, ["reload"]);
          //           }}
          //         />
          //       </Grid>
          //       <Grid item xs={12}>
          //         { !char_reloading && 
          //           <CharacterSheet
          //             char_id={char._id}
          //             character={char}
          //             height={window.innerHeight}
          //             width={window.innerWidth}
          //             updateCharacter={(changed: Character, pieces: string[] = ["all"]) => {
          //               updateCharacter(changed, pieces);
          //             }}
          //             onChange={() => {
          //               const new_obj = obj.clone();
          //               const log = new EncounterLog();
          //               log.participant_id = participant.participant_id;
          //               log.field = "character";
          //               log.value = "refresh";
          //               updateEncounter(new_obj, log);
          //             }}
          //           />
          //         }
          //       </Grid>
          //     </Grid>
          //   )
          // }
        } else if (participant.participant instanceof BasicCreatureInstance) {
          // debugger;
          const creature_instance = selected_ci_id === "" ? 
            (participant.child_participants.length > 0 ? 
              participant.child_participants[0] : participant.participant) :
            participant.child_participants.find(o => o.true_id === selected_ci_id);
          // console.log(creature_instance);
          if (creature_instance instanceof BasicCreatureInstance) {
            if (participant.parent_id === "") {
              return (
                <CreatureInstanceInput
                  creature_instance={creature_instance}
                  trim={obj.trim_stat_blocks}
                  true_id={creature_instance.true_id}
                  onChange={async (changed) => {
                    // debugger;
                    const new_obj = obj; // .clone();
                    if (changed instanceof BasicCreatureInstance) {
                      const the_participant = new_obj.participants.find(o => o.participant_id === participant.participant_id);
                      if (the_participant) {
                        const the_ci = the_participant.child_participants.find(o => o.true_id === changed.true_id);
                        if (the_ci) {
                          the_ci.copy(changed);
                        }
                      }
                    }
                    updateEncounter();
                    setCalculateTime(common_util.get_time_number());
                  }}
                  onSummon={ async (spell: CharacterAbility | CharacterSpell | Spell | CreatureAbility | MinionAbility, level: number, selected_option: SummonOption2) => {
                    const new_obj = obj; // .clone();
                    let add_time = common_util.get_time_number();
                    if (selected_option.creature) {
                      const creature = selected_option.creature;
                      // debugger;
                      let in_encounter = obj.participants.filter(o => o.creature_id === creature._id).length;
                      const creature_instances: BasicCreatureInstance[] = [];
                      for (let i = 0; i < selected_option.count; ++i) {
                        const new_creature_inst = new BasicCreatureInstance();
                        await new_creature_inst.copyCreature(creature);
                        new_creature_inst.name = new_creature_inst.name + (in_encounter > 0 ? ` ${in_encounter + 1}` : "");
                        in_encounter++;
                        creature_instances.push(new_creature_inst);
                      }
                      const the_participant = obj.participants.find(o => o.creature_id === creature._id);
                      if (the_participant) {
                        the_participant.child_participants = [...the_participant.child_participants,...creature_instances];
                      } else {
                        const new_participant = new EncounterParticipant();
                        new_participant.participant = creature_instances[0];
                        new_participant.participant_id = creature_instances[0].true_id;
                        new_participant.child_participants = creature_instances;
                        new_participant.creature_id = creature._id;
                        new_participant.owner_id = obj.owner_id;
                        new_participant.owner_name = api.user ? api.user.name : "";
                        new_participant.participant_type = "Creature";
                        new_participant.color = participant.color;
                        new_participant.add_time = add_time;
                        add_time++;
                        new_obj.participants.push(new_participant);
                        if (creature_instances[0].lair_actions.length > 0 && 
                          new_obj.participants.filter(o => o.participant_type === "Lair Actions").length === 0) {
                          const lair_actions_participant = new EncounterParticipant();
                          lair_actions_participant.initiative = 20;
                          lair_actions_participant.participant_id = "Lair Actions";
                          lair_actions_participant.owner_id = new_obj.owner_id;
                          lair_actions_participant.owner_name = api.user ? api.user.name : "";
                          lair_actions_participant.participant_type = "Lair Actions";
                          lair_actions_participant.add_time = add_time;
                          add_time++;
                          new_obj.participants.push(lair_actions_participant);
                        }
                      }
                    }
                    updateEncounter();
                    setCalculateTime(common_util.get_time_number());
                  }}
                />
              );
            } else {
              const char_participant = obj.participants.find(o => o.participant_id === participant.parent_id);
              if (char_participant && char_participant.participant instanceof Character) {
                return (
                  <CreatureInstanceInput
                    character={char_participant.participant}
                    creature_instance={creature_instance}
                    trim={obj.trim_stat_blocks}
                    true_id={creature_instance.true_id}
                    onChange={() => {
                      const new_obj = obj; // .clone();
                      const char_p = new_obj.participants.filter(o => o.participant_id === participant.parent_id)[0];
                      if (char_p && char_p.participant instanceof Character) {
                        const character = char_p.participant as Character;
                        api.updateCharacter(character, ["all"], true).then(res => {
                          setObj(new_obj);
                        });
                      } else {
                        setCalculateTime(common_util.get_time_number());
                      }
                    }}
                    onSummon={ async (spell: CharacterAbility | CharacterSpell | Spell | CreatureAbility | MinionAbility, level: number, selected_option: SummonOption2) => {
                      const new_obj = obj; // .clone();
                      let add_time = common_util.get_time_number();
                      if (selected_option.creature) {
                        const creature = selected_option.creature;
                        // debugger;
                        let in_encounter = obj.participants.filter(o => o.creature_id === creature._id).length;
                        const creature_instances: BasicCreatureInstance[] = [];
                        for (let i = 0; i < selected_option.count; ++i) {
                          const new_creature_inst = new BasicCreatureInstance();
                          await new_creature_inst.copyCreature(creature);
                          new_creature_inst.name = new_creature_inst.name + (in_encounter > 0 ? ` ${in_encounter + 1}` : "");
                          in_encounter++;
                          creature_instances.push(new_creature_inst);
                        }
                        
                        const the_participant = obj.participants.find(o => o.creature_id === creature._id);
                        if (the_participant) {
                          the_participant.child_participants = [...the_participant.child_participants,...creature_instances];
                        } else {
                          const new_participant = new EncounterParticipant();
                          new_participant.participant = creature_instances[0];
                          new_participant.participant_id = creature_instances[0].true_id;
                          new_participant.child_participants = creature_instances;
                          new_participant.creature_id = creature._id;
                          new_participant.owner_id = obj.owner_id;
                          new_participant.owner_name = api.user ? api.user.name : "";
                          new_participant.participant_type = "Creature";
                          new_participant.color = participant.color;
                          new_participant.add_time = add_time;
                          add_time++;
                          new_obj.participants.push(new_participant);
                          if (creature_instances[0].lair_actions.length > 0 && 
                            new_obj.participants.filter(o => o.participant_type === "Lair Actions").length === 0) {
                            const lair_actions_participant = new EncounterParticipant();
                            lair_actions_participant.initiative = 20;
                            lair_actions_participant.participant_id = "Lair Actions";
                            lair_actions_participant.owner_id = new_obj.owner_id;
                            lair_actions_participant.owner_name = api.user ? api.user.name : "";
                            lair_actions_participant.participant_type = "Lair Actions";
                            lair_actions_participant.add_time = add_time;
                            add_time++;
                            new_obj.participants.push(lair_actions_participant);
                          }
                        }
                      }
                      updateEncounter();
                      setCalculateTime(common_util.get_time_number());
                    }}
                  />
                );
              }
            }
          }
        } else if (participant.participant instanceof CustomParticipant) {
          // const custom_participant = participant.participant;
          // return (
          //   <CustomParticipantInstanceInput
          //     custom_participant={custom_participant}
          //     true_id={participant.participant_id}
          //     onChange={(log: EncounterLog) => {
          //       // const new_obj = obj.clone();
          //       // log.participant_id = participant.participant_id;
          //       updateEncounter();
          //     }}
          //   />
          // );
        } else if (participant.participant_type === "Lair Actions") {
          return (
            <LairActionsInput
              creature_instances={obj.participants.filter(o => o.participant instanceof BasicCreatureInstance && o.participant.lair_actions.length > 0).map(o => o.participant) as BasicCreatureInstance[] }
              onChange={() => {
                updateEncounter();
              }}
              onSummon={(spell: CharacterAbility | CharacterSpell | Spell | CreatureAbility | MinionAbility, level: number, selected_option: SummonOption2) => {
                // char_util.summonMinions(character, spell, level, selected_option, []).then(() => {
                //   updateCharacter(["features"]);
                //   setReloading(true);
                // });
              }}
            />
          );
        }
      } else if (obj.hide_description) {
        return null;
      } else {
        return (
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              <EditableLabel
                name="Description"
                value={obj.description}
                disabled={ !api.user || api.user._id !== obj.owner_id }
                multiline
                color=""
                fontSize={14}
                onChange={(changed: string) => {
                  const new_obj = obj; // .clone();
                  new_obj.description = changed;
                  updateEncounter();
                }}
              />
            </Grid>
          </Grid>
        );
      }
    }
  }
    
  const renderExtras = () => {
    if (mail_open && obj.campaign) {
      return (
        <SendToCharacters
          campaign={obj.campaign}
          open
          onClose={() => { setMailOpen(false); }}
        />
      );
    }
    return null;
  }

  if (!fetched || loading) {
    return (<div className="centered"><LoadingBox message={loading_message} size={window.innerHeight * 0.5} height={window.innerHeight - 81} /></div>);
  } else if (api.user === null) {
    return <Navigate to="/" />;
  } else if (!api.online) {
    return (
      <>Encounters only work while online.  Try reconnecting.</>
    );
  } else { 
    // debugger;
    // console.log(obj.clone());
    // console.log(calculate_time);
    const participant = obj.participants.find(o => o.participant_id === selected_participant_id);
    return (
      <Grid container spacing={0} direction="row" style={{ height: window.innerHeight - 80 }}>
        <Grid
          style={{ padding: "4px", height: "41px" }}
          size={{
            xs: 12,
            sm: 4
          }}>
          <EditableLabel
            name="Encounter Name"
            value={obj.name}
            flash_on_empty
            disabled={ !api.user || api.user._id !== obj.owner_id }
            onChange={(value: string) => {
              const new_obj = obj; // .clone();
              new_obj.name = value;
              updateEncounter();
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 8
          }}>
          <CenteredMenu
            options={["Description/Selection","Campaign","Add Participants"]}
            selected={view_mode}
            onSelect={setViewMode}
          />
        </Grid>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ height: window.innerHeight - 135 }}
          size={{
            xs: 12
          }}>
          <Grid
            className="padded"
            style={{ border: "1px solid" }}
            size={{
              xs: 12,
              sm: 4
            }}>
            <InitiativeTracker 
              obj={obj}
              change_time={change_time}
              calculate_time={calculate_time}
              height={window.innerHeight - 135}
              onChange={(recalc: boolean) => {
                if (recalc) {
                  const new_change_time = common_util.get_time_number();
                  updateEncounter(null, new_change_time);
                  setCalculateTime(new_change_time);
                }
              }}
              onSelect={(changed: string, ci_id = "") => {
                setSelectedParticipantID(changed);
                setSelectedCIID(ci_id);
                if (view_mode === "Description/Selection") {
                  setReLoadingView(true);
                }
              }}
            />
          </Grid>
          { (!obj.hide_description || view_mode === "Add Participants" || view_mode === "Campaign" || (participant && !(participant.participant instanceof Character))) &&
            <Grid
              className="padded"
              style={{ border: "1px solid" }}
              size={{
                xs: 12,
                sm: 8
              }}>
              <div style={{ height: window.innerHeight - 135, overflowY: "scroll" }}>
                <div className="padded">
                  { renderView() }
                </div>
              </div>
            </Grid>
          }
        </Grid>
      </Grid>
    ); 
  }
}
